export default __webpack_public_path__ + "static/media/BUE-Logo.2d9384d5.png";